<template>
    <div class="row">
        <div class="col m12">
            <blockquote>
                Autorización de materias
                <button v-on:click="getAutorizadas(0,0)" style="float:right" class="btn blue-ugb">Ver Autorizadas</button>
            </blockquote>
        </div>
    </div>
    <div class="row">
        <div class="col m4">
            <div class="row">
                <div class="col m7">
                <label>Facultad</label>
                    <select class="browser-default" v-model="facultad" v-on:change="this.codcar = 0; this.codpla = 0; this.planes = []; this.materias = [];">
                        <option value="0">Todas</option>
                        <option v-for="facultad in facultades" :key="facultad.fac_codigo" :value="facultad.fac_codigo">{{ facultad.fac_nombre }}</option>
                    </select>
                </div>
                <div class="col m5">
                    <br>
                    <button v-on:click="getAutorizadas(facultad,0)" style="float:right" class="btn blue-ugb btn-small">Ver Autorizadas</button>
                </div>
            </div>
            <table class="table tbl-condensed tbl-bordered striped" style="font-size: 12px;">
                <thead>
                    <tr>
                        <th>Carrera</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="carrera in carreras_filter" :key="carrera" :class="{'grey lighten-2': codcar == carrera.car_codigo}">
                        <td><a href="#!" v-on:click="getPlanes(carrera.car_codigo)">{{ carrera.car_nombre }}</a>
                            <br>
                            <span>{{ carrera.car_virtual == 'V' ? 'Virtual':carrera.car_sem_pres ? 'Semi-Presencial':'Presencial' }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="col m2">
            <span style="display:none">
                <label>null</label>
                <select class="browser-default" v-model="facultad">
                    <option value="0">Todas</option>
                </select>
            </span>
            <div class="row">
                <div class="col m12">
                    <br>
                    <button v-on:click="getAutorizadas(facultad, codcar)" style="float:right" class="btn blue-ugb btn-small">Ver Autorizadas</button>
                </div>
            </div>
            <table class="table tbl-condensed tbl-bordered striped" style="font-size: 12px;">
                <thead>
                    <tr>
                        <th>Plan</th>
                        <th style="width: 40%">Autorizadas</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="plan in planes" :key="plan" :class="{'grey lighten-2': codpla == plan.pla_codigo }">
                        <td><a href="#!" v-on:click="getMaterias(plan.pla_codigo)">{{ plan.pla_nombre }}</a></td>
                        <td class="center">{{ plan.pla_autorizadas }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="col m6">
            <label>Buscar materia</label>
            <input type="text" v-model="search" placeholder="Buscar..." style="border: solid 1px black">
            <table class="table tbl-condensed tbl-bordered striped" style="font-size: 12px;">
                <thead>
                    <tr>
                        <th style="width: 10%"># Mat.</th>
                        <th>Materia</th>
                        <th style="width: 7%">Ciclo</th>
                        <th style="width: 7%">UV</th>
                        <th style="width: 7%">Horarios</th>
                        <th style="width: 7%">Inscritos</th>
                        <th style="width: 10%">Autorizar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="materia in materias_filter" :key="materia" v-bind:class="{'blue lighten-5': (materia.plm_ciclo % 2 == 1)}">
                        <td class="center">{{ materia.plm_num_mat }}</td>
                        <td>{{ materia.mat_codigo }} - {{ materia.mat_nombre }}</td>
                        <td class="center">{{ materia.plm_ciclo }}</td>
                        <td class="center">{{ materia.plm_uv }}</td>
                        <td class="center">{{ materia.plm_horarios }}</td>
                        <td class="center">{{ materia.plm_inscritos }}</td>
                        <td class="center"><label><input type="checkbox" class="filled-in" v-model="materia.plm_autorizada" :checked="materia.plm_autorizada" v-on:click="setAutorizacion(materia.mat_codigo, $event)"><span></span></label></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div id="modal-autorizadas-lista" class="modal">
        <div class="modal-content">
            <div class="row">
                <div class="col m12">
                    <table class="table tbl-condensed tbl-bordered" style="font-size: 12px;">
                        <thead></thead>
                        <tbody>
                            <template v-for="facultad in autorizadas" :key="facultad">
                                <tr class="black white-text">
                                    <th colspan="4">{{ facultad.fac_nombre }}</th>
                                </tr>
                                <template v-for="carrera in facultad.ra_car_carreras" :key="carrera">
                                    <tr class="grey lighten-3">
                                        <td colspan="4">{{ carrera.car_nombre }}</td>
                                    </tr>
                                    <template v-for="plan in carrera.ra_pla_planes" :key="plan">
                                    <tr>
                                        <th colspan="4">{{ plan.pla_nombre.toUpperCase() }}</th>
                                    </tr>
                                    <tr>
                                        <th>Materia</th>
                                        <th>Ciclo</th>
                                        <th>Horarios</th>
                                        <th>Inscritos</th>
                                    </tr>
                                    <tr v-for="materia in plan.ra_mat_materias" :key="materia">
                                        <td>{{ materia.mat_codigo }} - {{ materia.mat_nombre }}</td>
                                        <td class="center">{{ materia.plm_ciclo}}</td>
                                        <td class="center">{{ materia.hor_grupos}}</td>
                                        <td class="center">{{ materia.mai_inscritos}}</td>
                                    </tr>
                                </template>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <a href="#!" class="modal-close btn blue-ugb">Aceptar</a>
        </div>
    </div>
</template>

<script>
import M from 'materialize-css'
    export default 
    {
        data(){
            return {
                carreras: [],
                codcar: 0,
                planes: [],
                codpla: 0,
                materias: [],
                facultades: [],
                facultad: 0,
                search: '',
                autorizadas: [],
                modales: []
            }
        },
        async mounted()
        {
            await this.getCarreras();
            await this.getFacultades();
            var elems = document.querySelectorAll('.modal');
            this.modales = M.Modal.init(elems, null);
        },
        methods: {
            async getCarreras()
            {
                this.$root.startLoading();
                await this.axios.get('/Carreras/AllAllowed')
                .then(response => {
                    this.carreras = response.data.filter(x=>x.tipo == 'U');
                });
                this.$root.stopLoading();
            },
            async getPlanes(codcar)
            {
                this.search = '';
                this.$root.startLoading();
                this.codcar = codcar;
                this.materias = [];
                await this.axios.get('/Carreras/' + codcar + '/PlanesAutorizadas')
                .then(response => {
                    this.planes = response.data;
                });
                this.$root.stopLoading();
            },
            async getMaterias(codpla)
            {
                this.search = '';
                this.$root.startLoading();
                this.codpla = codpla;
                await this.axios.get('/Planes/' + codpla + '/MateriasAutorizadas')
                .then(response => {
                    this.materias = response.data;
                });
                this.$root.stopLoading();
            },
            async getFacultades()
            {
                this.$root.startLoading();
                await this.axios.get('/Facultades')
                .then(response => {
                    this.facultades = response.data;
                });
                this.$root.stopLoading();
            },
            async getAutorizadas(codfac, codcar)
            {
                this.$root.startLoading();
                await this.axios.get('/MateriasAutorizadas/Autorizadas/' + codfac + '/' + codcar)
                .then(response => {
                    this.autorizadas = response.data;
                    var instance = M.Modal.getInstance(document.querySelector('#modal-autorizadas-lista'));
                    instance.open();
                });
                this.$root.stopLoading();
            },
            async setAutorizacion(codmat, event)
            {
                var payload = {
                    dma_codmau: 0,
                    dma_codpla: this.codpla,
                    dma_codmat: codmat,
                    dma_tipo: 'N',
                    dma_codigo: 0
                };
                this.$root.startLoading();
                await this.axios.post('/MateriasAutorizadas?status=' + event.target.checked, payload)
                .then(() => {
                    M.toast({html: 'La materia ha sido '+(event.target.checked ? 'autorizada':'desautorizada')+'.'});
                    var index_plan = this.planes.findIndex(x=>x.pla_codigo == this.codpla);
                    this.planes[index_plan].pla_autorizadas = this.materias.filter(x=>x.plm_autorizada).length;
                })
                .catch(error => {
                    M.toast({html: error.response.data.message});
                    event.target.checked = true;
                });
                this.$root.stopLoading();
            }
        },
        computed:{
            carreras_filter()
            {
                return this.carreras.filter(x=>x.car_codfac == (this.facultad == 0 ? x.car_codfac:this.facultad));
            },
            materias_filter()
            {
                return this.materias.filter(
                        x=>
                            x.mat_nombre.toLowerCase().indexOf(this.search.toLowerCase()) != -1 ||
                            x.mat_codigo.toLowerCase().indexOf(this.search.toLowerCase()) != -1
                        );
            }
        }
    }
</script>